import Masonry from 'react-masonry-css';

import { useIsMdDown } from '@/hooks/useMedia';

import type { CardProps } from '../Cms/Card';
import type { ContentGroupProps } from '../Cms/ContentGroup';
import { SinceHistoryItem } from './components/SinceHistoryItem';

import * as S from './SinceHistory.styles';

export const SinceHistory = (props: ContentGroupProps) => {
  const isMobileView = useIsMdDown();
  return (
    <S.Wrapper>
      <S.SinceWrapper>
        <S.HistoryWarpper>
          <Masonry
            breakpointCols={isMobileView ? 1 : 2}
            data-testid='my-masonry-grid'
            className='my-masonry-grid'
            columnClassName='my-masonry-grid_column'
          >
            {props.itemsCollection?.items.map((item) => {
              const ItemData = { ...item } as CardProps;
              return (
                <SinceHistoryItem
                  key={ItemData.sys.id}
                  {...ItemData}
                ></SinceHistoryItem>
              );
            })}
          </Masonry>
        </S.HistoryWarpper>
      </S.SinceWrapper>
    </S.Wrapper>
  );
};
